import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { MessageBar, MessageBarType, DefaultButton } from "@fluentui/react";
import { useTheme, logger } from "cayo.ui";
import styled from "styled-components";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import downloadUtils from "@cayo/shared/utils/download";
import { wizardMessages } from "../messages";
const log = logger.getLogger("GetAdConnector");

type ChooseConnectionProps = {
  setAdDownloaded: (data: boolean) => void;
};

const GetAdConnector = ({ setAdDownloaded }: ChooseConnectionProps) => {
  const intl = useIntl();
  const { cayoTheme } = useTheme();

  const handleClick = async () => {
    try {
      downloadUtils.downloadODataFile(
        `${endpoints.publicUrl}/v0/configuration/workerSystemNodes/downloadADAgent`
      );
      setAdDownloaded(true);
    } catch (error) {
      log.debug(error);
    }
  };

  return (
    <Wrapper>
      <MessageBar
        messageBarType={MessageBarType.info}
        truncated={true}
        styles={{
          root: {
            marginBottom: 10,
            background: cayoTheme.wizard.colors.active,
          },
        }}
      >
        {intl.formatMessage(wizardMessages.adConnectorDownLoadInfo, {
          link: (
            <a
              href={"https://support.cayosoft.com/hc/en-us/articles/43507970743821"}
              target="_blank"
              rel="noreferrer"
            >
              <FormattedMessage
                id={wizardMessages.LearnMore.id}
                defaultMessage={wizardMessages.LearnMore.defaultMessage}
              />
            </a>
          ),
        })}
      </MessageBar>
      <DownloadWrapper>
        <DownloadTitle>
          {intl.formatMessage(wizardMessages.adConnectorDownLoadButtonTitle)}
        </DownloadTitle>
        <DefaultButton
          onClick={handleClick}
          text={intl.formatMessage(wizardMessages.download)}
          iconProps={{ iconName: "Download" }}
        />
      </DownloadWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const DownloadTitle = styled.p`
  font-weight: 600;
  margin: 0px;
`;

const DownloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;

  button {
    width: 129px;
  }
`;

export default GetAdConnector;
